import React, { useState, useEffect, useRef } from "react";
import MobileMenu from "./MobileMenu";
import CartBox from "./CartBox";
import UserProfile from "./UserProfile";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet";
import api from "../api";
import Cookies from "js-cookie";

function Header({ cartItems, grandTotal, removeItemFromCart, wishlistCount, cartSummary }) {
  const [isSticky, setIsSticky] = useState(false);
  const location = useLocation();
  const [isMobileMenuVisible, setIsMobileMenuVisible] = useState(false);
  const [isSearchActive, setIsSearchActive] = useState(false);
  const [metaData, setMetaData] = useState({});
  const [settings, setSettings] = useState([]);
  const [categories, setCategories] = useState([]);
  // const [wishlistCount, setWishlistCount] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [results, setResults] = useState([]);
  const [showResults, setShowResults] = useState(false);
  const searchRef = useRef(null);
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();
    if (searchTerm.trim()) {
      window.location.href = `/search?query=${encodeURIComponent(searchTerm)}`;
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await api.get("/business-settings");
        setSettings(response.data.data.data);
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    const fetchCategoriesAndSubcategories = async () => {
      try {
        const response = await api.get("/categories");
        const fetchedCategories = response.data.data;

        // Fetch subcategories for each category
        const categoriesWithSubcategories = await Promise.all(
          fetchedCategories.map(async (category) => {
            const subResponse = await api.get(`/sub-categories/${category.id}`);
            return {
              ...category,
              subcategories: subResponse.data.data,
            };
          })
        );

        setCategories(categoriesWithSubcategories);
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchCategoriesAndSubcategories();
  }, []);

  useEffect(() => {
    if (Array.isArray(settings)) {
      const meta = {};
      settings.forEach((setting) => {
        if (setting.type === "header_logo_path") {
          meta.header_logo_path = setting.value;
        }
        if (setting.type === "site_icon_path") {
          meta.site_icon_path = setting.value;
        }
        if (setting.type === "website_name") {
          meta.website_name = setting.value;
        }
        if (setting.type === "header_top") {
          meta.header_top = setting.value;
        }
        if (setting.type === "website_topbar_content") {
          meta.website_topbar_content = setting.value;
        }
        if (setting.type === "topbar_link_name") {
          meta.topbar_link_name = setting.value;
        }
        if (setting.type === "topbar_banner_link") {
          meta.topbar_banner_link = setting.value;
        }
      });
      setMetaData(meta);
    }
  }, [settings]);

  useEffect(() => {
    const handleScroll = () => {
      setIsSticky(window.scrollY > 100);
    };

    window.addEventListener("scroll", handleScroll);

    // Clean up the event listener when the component unmounts
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const toggleMobileMenu = () => {
    setIsMobileMenuVisible((prev) => !prev);
    if (!isMobileMenuVisible) {
      document.body.classList.add("mobile-menu-visible");
    } else {
      document.body.classList.remove("mobile-menu-visible");
    }
  };

  const toggleSearchPopup = () => {
    setIsSearchActive((prev) => !prev);
    if (!isSearchActive) {
      document.body.classList.add("mobile-search-active");
    } else {
      document.body.classList.remove("mobile-search-active");
    }
  };

  const defaultMenuItems = [
    // { title: "Home", link: "/" },
    // { title: "Sale", link: "/products" },
  ];

  const categoryMenuItems = categories.map((category) => ({
    title: category.name,
    link: `/category/${category.slug}`,
    subMenu: category.subcategories?.map((sub) => ({
      title: sub.name,
      link: `/category/${sub.slug}`,
    })),
  }));

  const menuItems = [...defaultMenuItems, ...categoryMenuItems];

  const renderSubMenu = (subMenu) => {
    if (!subMenu || subMenu.length === 0) return null;

    return (
      <ul>
        {subMenu.map((item, index) => (
          <li key={index} className={item.subMenu ? "dropdown" : ""}>
            <Link to={item.link}>{item.title}</Link>
            {item.subMenu && renderSubMenu(item.subMenu)}
            {item.subMenu && <div className="dropdown-btn"><i className="fa-solid fa-angle-down"></i></div>}
          </li>
        ))}
      </ul>
    );
  };

  const renderMenuItems = () => {
  return menuItems.map((item, index) => (
  <li
    key={index}
    className={`menu-item ${item.subMenu && item.subMenu.length > 0 ? "dropdown" : ""}`}
    style={{ listStyle: "none", position: "relative", margin: 0 }}
  >
    <Link
      to={item.link}
      className="menu-link"
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "8px 12px",
        color: "#333",
        textDecoration: "none",
        transition: "color 0.3s",
      }}
    >
      {item.title}
      {item.subMenu && item.subMenu.length > 0 && (
        <i className="fa-solid fa-angle-down" style={{ marginLeft: "8px", fontSize: "0.8em" }}></i>
      )}
    </Link>

    {/* Submenu */}
    {item.subMenu && item.subMenu.length > 0 && (
      <ul className="submenu">
        {item.subMenu.map((sub, subIndex) => (
          <li key={subIndex}>
            <Link to={sub.link}>{sub.title}</Link>
          </li>
        ))}
      </ul>
    )}
  </li>
));

};


  useEffect(() => {
    const searchProducts = async () => {
      if (searchTerm.length >= 3) {
        try {
          const response = await api.get(`/products/search?name=${searchTerm}`);
          setResults(response.data.data);
          setShowResults(true);
        } catch (error) {
          console.error("Error fetching search results", error);
        }
      } else {
        setShowResults(false);
      }
    };

    const debounceSearch = setTimeout(() => {
      searchProducts();
    }, 500);

    return () => clearTimeout(debounceSearch);
  }, [searchTerm]);

  const handleKeyUp = (e) => {
    setSearchTerm(e.target.value);
  };

  const handleClick = (slug) => {
    setShowResults(false);
    navigate(`/products/${slug}`);
  };

  const handleClickOutside = (event) => {
    if (
      searchRef.current &&
      !searchRef.current.contains(event.target) &&
      !event.target.closest(".search-results")
    ) {
      setShowResults(false);
    }
  };

  const handleFocus = () => {
    if (results.length > 0) {
      setShowResults(true);
    }
  };

  useEffect(() => {
    const dropdowns = document.querySelectorAll(".dropdown");
    dropdowns.forEach((dropdown) => {
      const menu = dropdown.querySelector("ul");
      dropdown.addEventListener("mouseenter", () => {
        menu.style.display = "block";
      });
      dropdown.addEventListener("mouseleave", () => {
        menu.style.display = "none";
      });
    });
  }, []);

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);
  return (
    <>
      <Helmet>
        <title>{metaData.website_name}</title>
        <meta name="keywords" content={metaData.meta_keywords} />
        <meta name="title" content={metaData.meta_title} />
        <meta name="description" content={metaData.meta_description} />
        <meta name="csrf-token" content={metaData.csrf_token} />
      </Helmet>

      <header
        className={`main-header ${isSticky ? "fixed-header" : ""} ${isSearchActive ? "moblie-search-active" : ""}`}
      >
        {metaData.header_top && (
          <div className="header-top">
            <span
              className="header-top-text"
              dangerouslySetInnerHTML={{ __html: metaData.website_topbar_content }}
            ></span>
            &nbsp; | &nbsp;
            {metaData.topbar_banner_link && metaData.topbar_link_name && (
              <Link to={metaData.topbar_banner_link} className="header-top-link">
                {metaData.topbar_link_name}
              </Link>
            )}
          </div>
        )}

        <div
          className="header-lower"
          style={{
            background: "#fff",
            padding: "12px 0",
            borderBottom: "1px solid #eee",
          }}
        >
          <div
            className="main-box container-fluid px-4"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              flexWrap: "nowrap",
              gap: "20px",
            }}
          >
            {/* Left: Logo + Menu */}
            <div
              className="left-section"
              style={{
                display: "flex",
                alignItems: "center",
                gap: "25px",
                minWidth: "250px",
              }}
            >
              {/* Logo */}
              <Link to="/">
                <div className="logo-box">
                  <img
                    src={metaData.header_logo_path}
                    alt={metaData.website_name}
                    style={{ height: "40px", objectFit: "contain" }}
                  />
                </div>
              </Link>
              {/* Menu */}
              <ul
                className="navigation"
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "20px",
                  listStyle: "none",
                  margin: 0,
                  padding: 0,
                }}
              >
                <li>
                  <Link to="/" style={{ fontSize: "16px", fontWeight: "500", color: "#f17216" }}>
                    Home
                  </Link>
                </li>
                <li className="dropdown" style={{ position: "relative" }}>
                  <span style={{ fontSize: "16px", fontWeight: "500", color: "#000", cursor: "pointer" }}>
                    Categories <i className="fa fa-chevron-down" style={{ fontSize: "10px", marginLeft: "4px" }}></i>
                  </span>
                  <ul className="categoryList">{renderMenuItems()}</ul>
                </li>
                <li>
                  <Link to="/contact-us" style={{ fontSize: "16px", fontWeight: "500", color: "#000" }}>
                    Contact Us
                  </Link>
                </li>
              </ul>
            </div>

            {/* Center: Search */}
            <div
              className="search-box"
              ref={searchRef}
              style={{
                flex: 1,
                maxWidth: "600px",
              }}
            >
              <form method="post" onSubmit={handleSubmit} action="#" >
                <div
                  className="form-group"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    background: "#f8f8f8",
                    borderRadius: "50px",
                    padding: "2px 16px",
                  }}
                >
                  <button type="submit">
                    <i className="fa fa-search" style={{ marginRight: "8px" }}></i>
                  </button>

                  <input
                    type="search"
                    name="search-field"
                    placeholder="Search..."
                    onKeyUp={handleKeyUp}
                    onFocus={handleFocus}
                    required
                    style={{
                      border: "none",
                      background: "transparent",
                      flex: 1,
                      outline: "none",
                      fontSize: "14px",
                    }}
                  />
                </div>
              </form>
              {showResults && (
                <ul className="search-results mt-2">
                  {results.length > 0 ? (
                    results.map((item) => (
                      <li key={item.id} className="search-item">
                        <Link to={`/products/${item.slug}`} className="item-link">
                          <img
                            src={item.thumbnail_image}
                            alt={item.name}
                            className="item-image"
                          />
                          <div className="item-details">
                            <span className="item-name">{item.name}</span>
                            <span className="item-price">{item.main_price}</span>
                          </div>
                        </Link>
                      </li>
                    ))
                  ) : (
                    <li className="no-results">No results found</li>
                  )}
                </ul>
              )}
            </div>

            {/* Right: Icons */}
            <div
              className="right-section"
              style={{
                display: "flex",
                alignItems: "center",
                gap: "20px",
                minWidth: "200px",
                justifyContent: "flex-end",
              }}
            >
              <Link to="/wishlist" style={{ position: "relative" }}>
                <span className="icon lnr lnr-icon-heart" style={{ fontSize: "20px" }}></span>
                <span
                  style={{
                    position: "absolute",
                    top: "-8px",
                    right: "-12px",
                    background: "#39560e",
                    color: "#fff",
                    fontSize: "12px",
                    width: "20px",
                    height: "20px",
                    borderRadius: "50%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  {wishlistCount}
                </span>
              </Link>
              <UserProfile />
              <CartBox cartItems={cartItems} grandTotal={grandTotal} removeItemFromCart={removeItemFromCart} cartSummary={cartSummary} />
              <div className="mobile-nav-toggler" onClick={toggleMobileMenu}>
                <i className="fa fa-bars" style={{ fontSize: "20px" }}></i>
              </div>
            </div>
          </div>

        </div>

        {/* mobile header start */}
        <div className="mobile-header pt-4">
          <div className="container-fluid">
            <div className="row align-items-center">
              <div className="col-4 left-box">
                <div className="mobile-nav-toggler" onClick={toggleMobileMenu}>
                  <span className="icon lnr-icon-bars"></span>
                </div>
                <UserProfile />
              </div>
              <div className="col-4 logo-box">
                <a href="/">
                  <div className="logo">

                    <img
                      src={metaData.header_logo_path}
                      alt={metaData.website_name}
                    />

                  </div>
                </a>
              </div>
              <div className="col-4 right-box">
                <Link to="/wishlist" className="ui-btn ui-btn wishlist-btn">
                  <span className="icon lnr lnr-icon-heart"></span>
                  <span className="count" style={{ backgroundColor: "#39560e" }}>{wishlistCount}</span>
                </Link>
                <CartBox cartItems={cartItems} grandTotal={grandTotal} removeItemFromCart={removeItemFromCart} />
              </div>
              <div className="col-12 search-box py-1" ref={searchRef} >
                <div className="search-inner">
                  <form method="post" action="#">
                    <div className="form-group">
                      <input
                        type="search"
                        name="search-field"
                        placeholder="Search For a Product"
                        onKeyUp={handleKeyUp}
                        onFocus={handleFocus}
                        required
                      />
                      <button type="submit">
                        <i className="fa fa-search"></i>
                      </button>
                    </div>
                    {showResults && (
                      <ul className="search-results mt-2">
                        {results.length > 0 ? (
                          results.map((item) => (
                            <li key={item.id} className="search-item">
                              <Link to={`/products/${item.slug}`} className="item-link">
                                <img
                                  src={item.thumbnail_image}
                                  alt={item.name}
                                  className="item-image"
                                />
                                <div className="item-details">
                                  <span className="item-name">{item.name}</span>
                                  <span className="item-price">{item.main_price}</span>
                                </div>
                              </Link>
                            </li>
                          ))
                        ) : (
                          <li className="no-results">No results found</li>
                        )}
                      </ul>
                    )}

                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Mobile Menu */}
        <MobileMenu
          isVisible={isMobileMenuVisible}
          toggleMenu={toggleMobileMenu}
          menuItems={menuItems}
        />

        <div className={`sticky-header ${isSticky ? "fixed-header" : ""} d-none d-md-block`}>
          <div className="container-fluid">
            <div className="inner-container">
              <div className="logo">
                <Link to="/">
                  <img
                    src={metaData.header_logo_path}
                    alt={metaData.website_name}
                  />
                </Link>
              </div>
              <div className="nav-outer">
                <nav className="main-menu">
                  <div className="navbar-collapse show collapse clearfix">
                    <div
                      className="right-section"
                      style={{ display: "flex", alignItems: "center", gap: "20px" }}
                    >
                      <Link to="/wishlist" style={{ position: "relative" }}>
                        <span className="icon lnr lnr-icon-heart" style={{ fontSize: "20px" }}></span>
                        <span
                          style={{
                            position: "absolute",
                            top: "-8px",
                            right: "-12px",
                            background: "#39560e",
                            color: "#fff",
                            fontSize: "12px",
                            width: "20px",
                            height: "20px",
                            borderRadius: "50%",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          {wishlistCount}
                        </span>
                      </Link>

                      <UserProfile />

                      <CartBox
                        cartItems={cartItems}
                        grandTotal={grandTotal}
                        removeItemFromCart={removeItemFromCart}
                      />

                      <div className="mobile-nav-toggler" onClick={toggleMobileMenu}>
                        <i className="fa fa-bars" style={{ fontSize: "20px" }}></i>
                      </div>
                    </div>
                  </div>
                </nav>
                <div className="mobile-nav-toggler" onClick={toggleMobileMenu}>
                  <span className="icon lnr-icon-bars"></span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="marquee-wrapper">
          <div className="marquee-track">
            <div className="marquee-content">
              <span className="marquee-item">
                <i className="fa fa-truck me-2"></i> Free Shipping on orders above ₹2999
              </span>
              <span className="separator"></span>
              <span className="marquee-item">
                <i className="fa fa-star me-2"></i> New arrivals every week
              </span>
              <span className="separator"></span>
              <span className="marquee-item">
                <i className="fa fa-headset me-2"></i> 24/7 Customer Support
              </span>
            </div>
            {/* Duplicate for seamless loop */}
            <div className="marquee-content">
              <span className="marquee-item">
                <i className="fa fa-truck me-2"></i> Free Shipping on orders over ₹2999
              </span>
              <span className="separator"></span>
              <span className="marquee-item">
                <i className="fa fa-star me-2"></i> New arrivals every week
              </span>
              <span className="separator"></span>
              <span className="marquee-item">
                <i className="fa fa-headset me-2"></i> 24/7 Customer Support
              </span>
            </div>
          </div>
        </div>

      </header>
    </>
  );
}

export default Header;
